import * as React from "react";
const SvgPrimaryDelete = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M13.9 3.56a75 75 0 0 0-7.39-.369q-2.19 0-4.38.222L.625 3.56m4.056-.745.162-.966c.119-.7.207-1.224 1.453-1.224H8.23c1.246 0 1.342.553 1.452 1.232l.163.958m2.47 3.076-.48 7.426c-.08 1.158-.147 2.058-2.204 2.058H4.895c-2.058 0-2.124-.9-2.205-2.058l-.48-7.426m3.82 5.428h2.457m-3.068-2.95h3.687"
    />
  </svg>
);
export default SvgPrimaryDelete;
